var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.006 12.2427L3.73784 13.7872C3.52077 13.8234 3.33954 13.9727 3.26256 14.1788L0.0655198 22.7395C-0.240504 23.5263 0.583306 24.2769 1.3385 23.8994L23.4898 12.8254C24.1701 12.4853 24.1701 11.5147 23.4898 11.1746L1.3385 0.100619C0.583306 -0.276919 -0.240504 0.473701 0.0655198 1.2605L3.26256 9.82117C3.33954 10.0273 3.52077 10.1766 3.73784 10.2128L13.006 11.7573C13.1401 11.7796 13.2306 11.9064 13.2083 12.0405C13.191 12.1442 13.1097 12.2255 13.006 12.2427Z",
    fill: "#C5C5C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddComment);
export default __webpack_public_path__ + "static/media/add-comment.6ff8a49879aa5d9b6ba50620bc62425b.svg";
export { ForwardRef as ReactComponent };